import { Outlet, useMatches } from 'react-router';

import { AppShell } from '@/app/shell/AppShell';
import { AuthLayout } from '@/app/shell/AuthLayout';
import type { RouteLayout } from '@/app/route-manifest';
import { useIsSignedIn } from '@/stores/session.store';

/**
 * Une page ouverte à tous (la vérification d'un reçu) : dans l'ossature de
 * l'application pour un compte connecté, dans l'espace public sinon. Le retour
 * de Google (`bare`) n'a aucun habillage.
 */
export function PublicLayout() {
  const signedIn = useIsSignedIn();
  const matches = useMatches();
  const layout = (matches[matches.length - 1]?.handle as { layout?: RouteLayout } | undefined)?.layout;
  if (layout === 'bare') {
    return <Outlet />;
  }
  return signedIn ? <AppShell /> : <AuthLayout />;
}
